import { Helmet } from "react-helmet";
import Container from "../Container";
import ProgressBar from "../ProgressBar";
import AnimatedOutlet from "../AnimatedOutlet";

export default function OnboardingLayout() {
  return (
    <>
      <Helmet
        style={[
          {
            cssText: `
              body {
                background: var(--questionnaire-bg);
              }
            `,
          },
        ]}
      />
      <Container>
        <ProgressBar />
        <AnimatedOutlet />
      </Container>
    </>
  );
}
